import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { IOrderAcceptanceService, CHANNEL_ACCEPTANCE_SERVICE } from "../IOrderAcceptanceService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { BaseReplicaActionService } from "./BaseReplicaActionService";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OrderAcceptanceReplicaService
  extends BaseReplicaActionService
  implements IOrderAcceptanceService
{
  protected broker: ClientMessageBroker;
  modelNotificationFailureEventSubject: Subject<any> = new Subject<any>();
  protected clientRefreshPort: MessagePort = null;

  constructor(protected factory: ClientMessageBrokerFactory) {
    super();
    this.broker = this.factory.createMessageBroker(CHANNEL_ACCEPTANCE_SERVICE, true, true);
    this.initModelUpdateService(this.broker, this.clientRefreshPort);
  }

  public requestAcceptance(
    ids: Array<string>,
    comment: string,
    acceptanceAction: CubiqTS.AcceptanceAction,
    acceptanceType: CubiqTS.AcceptanceType,
    targetGroupId?: string,
    callOrderRateSide?: CubiqTS.RateSideType,
    orderType?: CubiqTS.OrderType,
    benchmarkOrderType?: CubiqTS.BenchmarkOrderType,
  ): Promise<any[]> {
    let request = new UiArguments("requestAcceptance");

    request.args = [
      new FnArg(ids, PRIMITIVE),
      new FnArg(comment, PRIMITIVE),
      new FnArg(acceptanceAction, PRIMITIVE),
      new FnArg(acceptanceType, PRIMITIVE),
      new FnArg(targetGroupId, PRIMITIVE),
      new FnArg(callOrderRateSide, PRIMITIVE),
      new FnArg(orderType, PRIMITIVE),
      new FnArg(benchmarkOrderType, PRIMITIVE),
    ];

    return this.broker.runOnService(request, PRIMITIVE);
  }

  getModelNotificationFailureEventSubject(): Subject<CubiqTS.ConcreteEncodable> {
    return this.modelNotificationFailureEventSubject;
  }
}
